// src/stage2/sceneExterior/TreelineForeground.jsx
import React, { useEffect, useMemo } from 'react';
import { useTexture } from '@react-three/drei';
import { useThree } from '@react-three/fiber';
import * as THREE from 'three';

export function TreelineForeground({
  // ✅ defaults now match your PlaygroundScene usage
  startX = -35,
  z = -30,
  segments = 10,
  width = 8,
  height = 5,
  y = 3.55,
  spacing = 0,
  rotationY = 0,
  textureUrl = '/stageAssets/stage2/scene/treelineForeground.png',
  renderOrder = 20, // between road (front) and mountain (back)
}) {
  const texture = useTexture(textureUrl);
  const { gl } = useThree();

  useEffect(() => {
    if (!texture) return;
    const maxAniso = gl.capabilities.getMaxAnisotropy();

    texture.anisotropy = maxAniso;
    texture.minFilter = THREE.LinearMipmapLinearFilter;
    texture.magFilter = THREE.LinearFilter;
    texture.needsUpdate = true;
  }, [texture, gl]);

  const cards = useMemo(() => {
    const step = width + spacing;
    return Array.from({ length: segments }, (_, i) => ({
      id: i,
      position: [startX + i * step, y, z],
      rotation: [0, rotationY, 0],
    }));
  }, [startX, y, z, segments, width, spacing, rotationY]);

  return (
    <group>
      {cards.map((card) => (
        <mesh
          key={card.id}
          position={card.position}
          rotation={card.rotation}
          renderOrder={renderOrder}
        >
          <planeGeometry args={[width, height]} />
          <meshBasicMaterial
            map={texture}
            alphaTest={0.15}     // adjust 0.05–0.25 if needed
            transparent={false}  // IMPORTANT: do NOT blend
            depthTest={true}
            depthWrite={true}
            toneMapped={false}
          />
        </mesh>
      ))}
    </group>
  );
}
